import * as actionTypes from '../action-types';
import { AggregationsType } from '../../search.types';
import { SearchActions, QueryParamsActions } from '../actions';

export const defaultState: AggregationsType = {
  domaine: [],
  juridiction: [],
  publi: [],
  solution: [],
  dates: [],
  ville: [],
  parties: [],
  exclude: [],
  publisher: [],
  textCode: [],
  collectiveAgreements: [],
  otherLegislation: [],
};

export function aggregationsReducer(
  state: AggregationsType = defaultState,
  action: SearchActions | QueryParamsActions,
) {
  switch (action.type) {
    case actionTypes.SYNC_QUERY_RESPONSE: {
      const { aggregations } = action.payload.response;
      return { ...aggregations };
    }
    case actionTypes.UPDATE_TYPE: {
      return { ...defaultState };
    }
    default:
      return state;
  }
}
